import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-96a733c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("全部")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("用户")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("商家")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("重置搜索")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("状态： ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("状态： ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_16 = {
  key: 9,
  class: "action_btn_box"
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode("详情")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 不通过 ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("通过")
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding-bottom":"10px","font-weight":"700"} }, "请输入不通过的原因", -1))
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "preview_box" }
const _hoisted_23 = { class: "preview_item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "身份证人像面", -1))
const _hoisted_25 = { class: "preview_item" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "身份证国徽面", -1))
const _hoisted_27 = { class: "preview_item" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "手持身份证", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_image_preview_group = _resolveComponent("a-image-preview-group")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, {
      title: "实名认证列表",
      style: {"margin-bottom":"16px"},
      bordered: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          layout: "inline",
          class: "search_box"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "来源",
              class: "search_item"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _ctx.searches.type,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searches.type) = $event)),
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSearch('type', $event))),
                  style: {"width":"100px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: "" }, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "1" }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "0" }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "搜索",
              class: "search_item"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_search, {
                  value: _ctx.searches.name,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searches.name) = $event)),
                  "enter-button": "",
                  onSearch: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSearch('name', $event))),
                  placeholder: "姓名搜索"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { class: "search_item" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_tooltip, null, {
                  title: _withCtx(() => [
                    _hoisted_4
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "dashed",
                      onClick: _ctx.resetSearch
                    }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_table, {
      dataSource: _ctx.list,
      columns: _ctx.columns,
      loading: _ctx.loading,
      bordered: "",
      pagination: _ctx.pagination,
      onChange: _ctx.handleTableChange
    }, {
      bodyCell: _withCtx(({ column, text, record }) => [
        (column.key === 'card_number')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", null, "身份证号：" + _toDisplayString(text), 1),
              _createElementVNode("div", null, "民族： " + _toDisplayString(record.nation), 1),
              _createElementVNode("div", null, "有效期：" + _toDisplayString(_ctx.formatTime(record.valid_time_start, false)) + "至" + _toDisplayString(_ctx.formatTime(record.valid_time_end, false)), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'user')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (record.shop_admin_id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", null, "姓名：" + _toDisplayString(record.admin?.name), 1),
                    _createElementVNode("div", null, "手机号：" + _toDisplayString(record.admin?.mobile), 1)
                  ]))
                : _createCommentVNode("", true),
              (record.user_id && !record.shop_admin_id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", null, "昵称：" + _toDisplayString(text?.nickname), 1),
                    _createElementVNode("div", null, "手机号：" + _toDisplayString(text?.mobile), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'review_time')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode(_toDisplayString(_ctx.formatTime(text)), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'shop_admin_id')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createTextVNode(_toDisplayString(text ? '司机端' : '用户端'), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'sex')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              _createTextVNode(_toDisplayString(text === 0 ? '女' : text === 1 ? '男' : '保密'), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'drivinglicenseu')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
              text
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", null, "姓名：" + _toDisplayString(text.name), 1),
                    _createElementVNode("div", null, "驾驶证号：" + _toDisplayString(text.license_number), 1),
                    _createElementVNode("div", null, [
                      _hoisted_9,
                      _createVNode(_component_a_badge, {
                        color: _ctx.statusText[text.status].color
                      }, null, 8, ["color"]),
                      _createElementVNode("span", {
                        style: _normalizeStyle({color: _ctx.statusText[text.status].color})
                      }, _toDisplayString(_ctx.statusText[text.status].name), 5)
                    ]),
                    _createVNode(_component_a_button, {
                      size: "small",
                      type: "primary",
                      onClick: ($event: any) => (_ctx.goDrivingDetail(text.id))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
              (!text && record.drivinglicensea)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", null, "姓名：" + _toDisplayString(record.drivinglicensea.name), 1),
                    _createElementVNode("div", null, "驾驶证号：" + _toDisplayString(record.drivinglicensea.license_number), 1),
                    _createElementVNode("div", null, [
                      _hoisted_12,
                      _createVNode(_component_a_badge, {
                        color: _ctx.statusText[record.drivinglicensea.status].color
                      }, null, 8, ["color"]),
                      _createElementVNode("span", {
                        style: _normalizeStyle({color: _ctx.statusText[record.drivinglicensea.status].color})
                      }, _toDisplayString(_ctx.statusText[record.drivinglicensea.status].name), 5)
                    ]),
                    _createVNode(_component_a_button, {
                      size: "small",
                      type: "primary",
                      onClick: ($event: any) => (_ctx.goDrivingDetail(record.drivinglicensea.id))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'courier' && text)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
              _createElementVNode("div", null, "业户名称：" + _toDisplayString(text.transportation_owner), 1),
              _createElementVNode("div", null, "经营许可号：" + _toDisplayString(text.road_transportation_permit_card), 1),
              _createElementVNode("div", null, "行驶证所有人：" + _toDisplayString(text.vehicle_travel_owner), 1),
              _createElementVNode("div", null, "行驶证车牌号：" + _toDisplayString(text.vehicle_travel_license_number), 1),
              _createVNode(_component_a_button, {
                size: "small",
                type: "primary",
                onClick: ($event: any) => (_ctx.goLicenceDetail(text.id))
              }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 2
              }, 1032, ["onClick"])
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'status')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
              _createVNode(_component_a_badge, {
                color: _ctx.statusText[text].color
              }, null, 8, ["color"]),
              _createElementVNode("span", {
                style: _normalizeStyle({color: _ctx.statusText[text].color})
              }, _toDisplayString(_ctx.statusText[text].name), 5)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'image')
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 8,
              size: "small",
              onClick: () => _ctx.setShow(record, true),
              type: "primary"
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 2
            }, 1032, ["onClick"]))
          : _createCommentVNode("", true),
        (column.key === 'action')
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createVNode(_component_a_button, {
                size: "small",
                class: "action_btn",
                onClick: ($event: any) => (_ctx.goDetail(record))
              }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 2
              }, 1032, ["onClick"]),
              (record.status === 0 || record.status === 1)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    size: "small",
                    class: "action_btn",
                    onClick: ($event: any) => (_ctx.setVisible(record, true)),
                    type: "primary",
                    danger: true
                  }, {
                    default: _withCtx(() => [
                      _hoisted_18
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_a_popconfirm, {
                title: "确定审核通过吗?",
                "ok-text": "确定",
                "cancel-text": "取消",
                onConfirm: ($event: any) => (_ctx.onAudit(record, true))
              }, {
                default: _withCtx(() => [
                  (record.status === 0)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        size: "small",
                        class: "action_btn",
                        type: "primary"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_19
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["onConfirm"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "columns", "loading", "pagination", "onChange"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.visible) = $event)),
      title: "审核不通过",
      onOk: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onAudit(_ctx.item, false))),
      onCancel: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setVisible(undefined, false))),
      confirmLoading: _ctx.loading
    }, {
      default: _withCtx(() => [
        _hoisted_20,
        _createVNode(_component_a_textarea, {
          value: _ctx.reason,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.reason) = $event)),
          placeholder: "请输入不通过的原因",
          rows: 4
        }, null, 8, ["value"])
      ]),
      _: 1
    }, 8, ["visible", "confirmLoading"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.show,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.show) = $event)),
      title: "预览",
      footer: null,
      width: "1000px",
      onCancel: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setShow(undefined, false)))
    }, {
      default: _withCtx(() => [
        (_ctx.item)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createVNode(_component_a_image_preview_group, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_a_image, {
                        src: _ctx.item?.card_image_just,
                        height: 200,
                        width: 200
                      }, null, 8, ["src"]),
                      _hoisted_24
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_a_image, {
                        src: _ctx.item?.card_image_back,
                        height: 200,
                        width: 200
                      }, null, 8, ["src"]),
                      _hoisted_26
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_a_image, {
                        src: _ctx.item?.card_image_hold,
                        height: 200,
                        width: 200
                      }, null, 8, ["src"]),
                      _hoisted_28
                    ])
                  ])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}